import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class TaskManagerTableDto extends NamedDto {
	constructor() {
		super();

		/** @type {NamedDto} */
		this.user = null;

		/** @type {string} */
		this.schedule = null;

		/** @type {boolean} */
		this.enabled = null;

		/** @type {string} */
		this.type = null;

		/** @type {number} */
		this.fileCount = null;

		/** @type {number} */
		this.okCount = null;

		/** @type {number} */
		this.failCount = null;

		/** @type {Date} */
		this.lastStarted = null;

		/** @type {string} */
		this.lastStatus = null;

		/** @type {Date} */
		this.lastTimestamp = null;

		/** @type {string} */
		this.lastMessage = null;

		/** @type {string} */
		this.lastResult = null;

		/** @type {string} */
		this.meta = null;

		/** @type {Object} */
		this.state = null;
	}

	/**
	 * @typedef {Object} _TaskManagerTableDtoProps
	 * @property {NamedDto} user
	 * @property {string} schedule
	 * @property {boolean} enabled
	 * @property {string} type
	 * @property {number} fileCount
	 * @property {number} okCount
	 * @property {number} failCount
	 * @property {Date} lastStarted
	 * @property {string} lastStatus
	 * @property {Date} lastTimestamp
	 * @property {string} lastMessage
	 * @property {string} lastResult
	 * @property {string} meta
	 * @property {Object} state
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _TaskManagerTableDtoProps} TaskManagerTableDtoProps
	 */
	/**
	 *
	 * @param {TaskManagerTableDtoProps} props
	 * @returns {TaskManagerTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.user = props.user !== null ? new NamedDto().setup(props.user) : null;
		this.schedule = props.schedule;
		this.enabled = props.enabled === null ? false : props.enabled;
		this.type = props.type;
		this.fileCount = props.fileCount;
		this.okCount = props.okCount;
		this.failCount = props.failCount;
		this.lastStarted = props.lastStarted ? new Date(props.lastStarted) : null;
		this.lastStatus = props.lastStatus;
		this.lastTimestamp = props.lastTimestamp ? new Date(props.lastTimestamp) : null;
		this.lastMessage = props.lastMessage;
		this.lastResult = props.lastResult;
		this.meta = props.meta;
		this.state = props.state;

		return this;
	}

	getAsString(key) {
		return super.getAsString(key);
	}
}
